// @flow
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Widget from "app/components/Widget";
import BulletList from "app/components/BulletList";
import styles from "./PostRelated.styles";

class PostRelated extends React.Component<Props> {
  componentDidMount() {}

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.titleWrapper}>
        <div className={classes.titleLine}>
          <h3 className={classes.title}>
            مطالب مرتبط
          </h3>
        </div>
        <Widget className={{title: classes.widgetTitle}} gray>
          <BulletList list={this.props.list} />
        </Widget>
      </div>
    );
  }
}

const Component = withStyles(styles)(PostRelated);
export { Component as PostRelated };
export default Component;